import React from 'react';

export default function CoverageIcon() {
  return (
    <svg width="20" height="20">
      <defs>
        <path
          id="coverage-a"
          d="M6.37.135C6.263.09 6.13.045 6.023 0c-.11.045-.24.09-.35.135-1.287.471-2.727.988-4.32.988C.896 1.123.459 1.1 0 1.055v7.792c0 1.707 1.658 3.301 3.033 4.334C4.298 14.124 5.585 14.775 6 15c.938-.472 6-3.099 6-6.153v-7.77a13.01 13.01 0 01-1.353.068C9.098 1.123 7.637.606 6.371.135zM4.757 10.262L2.422 7.859l1.025-1.055 1.31 1.347 4.188-4.334 1.026 1.056-5.215 5.389z"
        />
      </defs>
      <g fill="none" fillRule="evenodd" transform="translate(4 3)">
        <mask id="coverage-b" fill="#fff">
          <use xlinkHref="#coverage-a" />
        </mask>
        <use fill="#50565B" fillRule="nonzero" xlinkHref="#coverage-a" />
        <g fill="#50565B" fillRule="nonzero" mask="url(#coverage-b)">
          <path d="M-4-3h20v20H-4z" />
        </g>
      </g>
    </svg>
  );
}
